export default __webpack_public_path__ + "static/media/BMCM_Business_Continuity_Planning_disclosure.36cfaa8d.pdf";